import {DialogTypes} from 'common/names';
import {layoutActions} from 'features/layout/redux';
import i18n from 'i18n';
import {call, put, race} from 'redux-saga/effects';
import {takeDialogResult} from 'redux/common/saga/takeDialogResult';
import {initMergeProcess} from './initMergeProcess';

export function* openMergeDialog(dbFilePath: string, password: string, overwrite: boolean) {
   console.debug('!DO merge', dbFilePath, password, overwrite);

   yield put(
      layoutActions.openSubDialog({
         id: DialogTypes.StatusDialog.id,
         data: {
            title: i18n.t('Transaction Datastore Merge'),
         },
      })
   );

   yield race([
      call(takeDialogResult, DialogTypes.StatusDialog.id),
      call(initMergeProcess, dbFilePath, password, overwrite),
   ]);
}
